import { useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Box } from 'foundations-components/transitional/components/Box';
import Small from 'UIComponents/elements/Small';
import NameCellHoverContent from './NameCellHoverContent';
import { StickyHoverCellNameColumn } from '../styled/StickyCellNameColumn';
import OnboardingRepTableTourStep from '../tour/OnboardingRepTableTourStep';
import { FormattedPeriod } from '../../components/overviewTable/FormattedPeriod';
import { getTimePeriodFilter } from '../../selectors/filtersSelectors';
import { getFiscalOffset } from '../../selectors/portalSettings';
import { isTimePeriodCustom } from '../../utils/dateUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TotalsNameCell = ({
  onNameCellViewDealsClick,
  rowData
}) => {
  const fiscalOffset = useSelector(getFiscalOffset);
  const timePeriod = useSelector(getTimePeriodFilter);
  const {
    id,
    teamName
  } = rowData;
  const isCustomPeriod = isTimePeriodCustom(timePeriod);
  const formattedDateRange = /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FormattedPeriod, {
      offset: fiscalOffset,
      timePeriod: timePeriod
    }), ' ', !isCustomPeriod && /*#__PURE__*/_jsx(FormattedMessage, {
      message: "repOverviewTable.totalLowercase"
    })]
  });
  const content = /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    alignItems: "start",
    children: [/*#__PURE__*/_jsx(Box, {
      "data-test-id": "name-cell-name",
      children: teamName || /*#__PURE__*/_jsx(FormattedMessage, {
        message: "breadcrumbs.default"
      })
    }), /*#__PURE__*/_jsx(Small, {
      "data-test-id": "name-cell-subtext",
      weight: "regular",
      children: formattedDateRange
    })]
  });
  const hoverContent = id && /*#__PURE__*/_jsx(NameCellHoverContent, {
    onClick: () => {
      onNameCellViewDealsClick({
        dealSidebarId: id,
        isTeam: !!id
      });
    }
  });
  return /*#__PURE__*/_jsx(OnboardingRepTableTourStep, {
    children: /*#__PURE__*/_jsx(StickyHoverCellNameColumn, {
      hoverContent: hoverContent,
      children: content
    })
  });
};
export default TotalsNameCell;